// Module
var code = "<input type=\"checkbox\" class=\"binarytoggle-checkbox\" id=\"<%= id %>\" <% if (isChecked) print(\"checked\")%>>\n<label class=\"binarytoggle-label\" for=\"<%= id %>\">\n    <div class=\"binarytoggle-inner\" data-before=\"<%= before %>\" data-after=\"<%= after %>\"></div>\n    <div class=\"binarytoggle-switch\"></div>\n</label>";
// Exports
module.exports = code;